<template>
  <global-modal name="event-modal-managers">
    <Modal @close="$modal.hide('event-modal-managers')">
      <section class="event-modal-managers">
        <template v-if="isEventMontage">
          <h2 class="event-modal-managers__title">
            {{ $t("event.managers.titleMontage") }}
          </h2>

          <p class="event-modal-managers__manager-subtitle">
            {{ $t("event.managers.descriptionMontage") }}
          </p>
        </template>

        <template v-else>
          <h2 class="event-modal-managers__title">
            {{ $t("event.managers.title") }}
          </h2>

          <p class="event-modal-managers__manager-subtitle">
            {{ $t("event.managers.description") }}
          </p>
        </template>

        <div class="event-modal-managers__content">
          <div
            class="event-modal-managers__manager"
            v-for="(manager, i) in managers"
            :key="i"
          >
            <div class="event-modal-managers__manager-image">
              <img
                v-if="manager.image && manager.image.thumbnail_path"
                :src="getImage(manager)"
                :alt="getName(manager)"
              />

              <img
                v-else
                src="/public/static/images/event-no-company-image.svg"
                :alt="getName(manager)"
              />
            </div>

            <div class="event-modal-managers__manager-info">
              <h2 class="event-modal-managers__manager-info-name">
                {{ getName(manager) }}
              </h2>

              <p class="event-modal-managers__manager-info-mail">
                <a :href="mailto(manager.email)">{{ manager.email }}</a> <br />
                <a :href="telto(manager.phone)"> {{ manager.phone }} </a>
              </p>
            </div>
          </div>
        </div>
        <div class="flex">
          <div v-if="catalogManagers.length">
            <p class="event-modal-managers__manager-subtitle">
              {{ $t("event.managers.titleCatalog") }}
            </p>
            <div class="event-modal-managers__content column">
              <div
                class="event-modal-managers__manager"
                v-for="(manager, i) in catalogManagers"
                :key="i"
              >
                <div class="event-modal-managers__manager-image">
                  <img
                    v-if="manager.image && manager.image.thumbnail_path"
                    :src="getImage(manager)"
                    :alt="getName(manager)"
                  />

                  <img
                    v-else
                    src="/public/static/images/event-no-company-image.svg"
                    :alt="getName(manager)"
                  />
                </div>

                <div class="event-modal-managers__manager-info">
                  <h2 class="event-modal-managers__manager-info-name">
                    {{ getName(manager) }}
                  </h2>

                  <p class="event-modal-managers__manager-info-mail">
                    <a :href="mailto(manager.email)">{{ manager.email }}</a>
                    <br />
                    <a :href="telto(manager.phone)"> {{ manager.phone }} </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p class="event-modal-managers__manager-subtitle">
              {{ $t("event.managers.titleService") }}
            </p>
            <div class="event-modal-managers__manager-info-bureau">
              <h2 class="event-modal-managers__manager-info-name">
                {{ $t("event.managers.serviceBureau") }}
              </h2>

              <p class="event-modal-managers__manager-info-mail">
                <a :href="mailto('usluga@expocentr.ru')">usluga@expocentr.ru</a>
                <br />
                <a :href="telto('+74997953779')">+7(499) 795-37-79 </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import { mapGetters } from "vuex";

import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalManagers",

  components: {
    Modal
  },

  computed: {
    ...mapGetters("event", ["managers", "isEventMontage"]),
    ...mapGetters("eventCatalog", {
      catalogManagers: "managers"
    }),
    locale() {
      return i18n.locale;
    }
  },

  methods: {
    mailto(str) {
      return `mailto:${str}`;
    },

    telto(str) {
      return `tel:${str}`;
    },

    getName(manager) {
      if (i18n.locale === "en") {
        return `${manager.lastname_eng} ${manager.name_eng} ${manager.middlename_eng}`;
      } else {
        return `${manager.lastname_rus} ${manager.name_rus} ${manager.middlename_rus}`;
      }
    },
    getImage(manager) {
      return `${process.env.VUE_APP_URL}storage/${manager.image.thumbnail_path}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-managers {
  padding: 55px 170px 65px 80px;
  max-width: 780px;
  width: 100%;

  @include respond-down(lg) {
    padding: 47px 24px 64px 24px;
    box-sizing: border-box;
  }

  @include respond-down(md) {
    padding: 24px 16px 32px 16px;
    box-sizing: border-box;
  }

  &__title {
    @include h1();
    &.small {
      font-size: 28px;
    }
    margin-bottom: 30px;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    &.column {
      flex-direction: column;
    }
  }

  &__content &__manager {
    margin-right: 20px;
    margin-bottom: 50px;

    flex-shrink: 0;
  }

  &__manager {
    display: flex;
    width: 350px;

    @include respond-down(md) {
      max-width: 320px;
      width: 100%;
    }
    &-subtitle {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.43;
      color: #000000;
      margin-bottom: 30px;
      @include respond-down(md) {
        margin-bottom: 15px;
      }
    }
    &-image {
      width: 120px;

      @include respond-down(md) {
        width: 100px;
      }

      flex-shrink: 0;

      img {
        width: 100%;
      }
    }

    &-info {
      margin-left: 20px;

      &-name {
        padding: 0;
        margin: 0 0 5px 0;
        font-size: 13px;
        font-weight: normal;
      }
      &-bureau {
        margin: 0;
      }
      &-mail {
        margin: 0;
        padding: 0;

        font-size: 13px;
        line-height: 1.8em;

        &-position {
          @include description();
        }

        a {
          @include hyperlink();
          font-size: inherit;
        }
      }
    }
  }
}
.flex {
  display: flex;
  @include respond-down(lg) {
    flex-direction: column;
  }
}
</style>
